<div class="recommendation-groups-panel-layout layout-column">
  <div class="title-container layout-row layout-align-space-between-center p-3">
    <div class="title-section layout-row layout-align-start-center">
      <bringoz-icon fill="blue" iconName="star-blue"></bringoz-icon>
      <div class="panel-title">{{ 'Visit Alerts & Recommendations' | translate }}</div>
    </div>
    <bringoz-button *ngIf="generateRecommendationsAllowed"
                    type="tertiary"
                    size="sm"
                    appBringozIdGenerator="recommendations_generate_visit_plan"
                    (onClick)="onSelectAgent($event)">
      <span>{{ 'RECOMMENDATIONS.GENERATE_RECOMMENDATIONS' | translate }}</span>
    </bringoz-button>
    <bringoz-button type="tertiary"
                    size="sm"
                    class="close-button"
                    (onClick)="closePanel()">
      <bringoz-icon classSize="xl" iconName="close"></bringoz-icon>
    </bringoz-button>
  </div>

  <div class="recommendation-groups-list-wrapper flex layout-column" *ngIf="!(selectedRecommendationGroup$ | async)">
    <app-recommendation-groups-list-items
      [recommendationGroups]="recommendationGroups$ | async"
      [loading]="loading$ | async"
      (onSelectGroup)="onSelectGroup($event)"
      (fetchNextEvent)="onFetchNext()">
    </app-recommendation-groups-list-items>
  </div>

  <div class="recommendations-list-wrapper flex layout-column" *ngIf="selectedRecommendationGroup$ | async as selectedRecommendationGroup">
    <div class="override-back-button py-3 px-2">
      <bringoz-button type="tertiary"
                      size="xl"
                      (onClick)="onBack()">
        <bringoz-icon fill="#aaa" classSize="xl" iconName="arrow-left"></bringoz-icon>
        <span class="group-name">{{selectedRecommendationGroup.name}}</span>
      </bringoz-button>
    </div>
    <app-recommendations-list-items
      [recommendations]="recommendations$ | async"
      [loading]="loading$ | async"
      [showRecommendationLink]="true"
      (updateRecommendation)="updateRecommendationFeedback($event)"
      (goToRecommendation)="goToRecommendation(selectedRecommendationGroup.name, $event)"
      (markRecommendationAsRead)="markRecommendationAsRead($event)"
      (openRoutePanelsByIds)="openRoutePanelsByIds.emit($event)">
    </app-recommendations-list-items>
  </div>

</div>

